import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { users } from '../../api';
import { isObject } from '../../../utils/utils';
import { useHistory } from 'react-router';

export const useCreateUser = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation(['create-user'], ({ params }) => users.createUser(params), {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['users']);
            toast.success(t('User successfully created'));
            history.push('/chain/users');
        },
        onError: (error) => {
            if (isObject(error.response?.data?.data)) {
                Object.values(error.response?.data?.data).forEach((error) => {
                    toast.error(error?.[0]);
                });
            } else {
                toast.error(error.response?.data?.message);
            }
        },
    });
};
